import { NullArray, Scalar, Variables } from "@urql/exchange-graphcache";
import {
  MatchingDashboardMenteesDocument,
  MatchingDashboardMenteesQuery,
  SavedMatchesDocument,
  SavedMatchesQuery,
} from "../generated/graphql";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function InvalidateCachedSavedMatches(cache: any) {
  // There may be multiple queries, one for each filtered list that was cached.
  const savedMatchQueries = cache
    .inspectFields("Query")
    .filter((f: { fieldName: string }) => f.fieldName === "savedMatches");

  savedMatchQueries.forEach(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ fieldName, arguments: variables }: { fieldName: string; arguments: any }) => {
      if (variables) {
        cache.invalidate("Query", fieldName, variables);
      }
    }
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function RemoveFromCachedSavedMatches(savedMatchIds: string[], cache: any) {
  if (!savedMatchIds) {
    return;
  }

  // There may be multiple queries, one for each filtered list that was cached.
  const savedMatchQueries = cache
    .inspectFields("Query")
    .filter((f: { fieldName: string }) => f.fieldName === "savedMatches");

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  savedMatchQueries.forEach((savedMatchQuery: { arguments: any }) =>
    cache.updateQuery(
      {
        query: SavedMatchesDocument,
        variables: savedMatchQuery.arguments,
      },
      (data: SavedMatchesQuery | null) => {
        if (data?.savedMatches?.nodes) {
          data.savedMatches.nodes = data.savedMatches.nodes.filter((savedMatch) => {
            return !savedMatchIds.includes(savedMatch.id);
          });
          data.savedMatches.totalCount = data.savedMatches.nodes.length;
        }
        return data;
      }
    )
  );
}

export function RemoveMenteeFromCachedMenteeList(
  studentId: Variables | Scalar | Scalar[] | NullArray<Variables>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cache: any
) {
  if (!studentId) {
    return;
  }

  // There may be multiple queries, one for each filtered list that was cached.
  const matchingDashboardMenteeQueries = cache
    .inspectFields("Query")
    .filter(
      (f: { fieldName: string; fieldKey: string }) =>
        f.fieldName === "participants" && f.fieldKey.includes('"type":"STUDENTS"')
    );

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  matchingDashboardMenteeQueries.forEach((query: { arguments: any }) =>
    cache.updateQuery(
      {
        query: MatchingDashboardMenteesDocument,
        variables: query?.arguments,
      },
      (data: MatchingDashboardMenteesQuery | null) => {
        if (data?.participants?.nodes) {
          data.participants.nodes = data.participants.nodes.filter(
            (participant) => participant.id !== studentId.toString()
          );
          data.participants.totalCount = data.participants.nodes.length;
        }
        return data;
      }
    )
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function InvalidateCachedMentees(cache: any) {
  const matchingDashboardMentees = cache
    .inspectFields("Query")
    .filter(
      (f: { fieldName: string; fieldKey: string }) =>
        f.fieldName === "participants" && f.fieldKey.includes('"type":"STUDENTS"')
    );

  matchingDashboardMentees.forEach(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ fieldName, arguments: variables }: { fieldName: string; arguments: any }) => {
      if (variables) {
        cache.invalidate("Query", fieldName, variables);
      }
    }
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function InvalidateCachedMentors(cache: any) {
  const matchingDashboardMentors = cache
    .inspectFields("Query")
    .filter(
      (f: { fieldName: string; fieldKey: string }) =>
        f.fieldName === "participants" && f.fieldKey.includes('"type":"MENTORS"')
    );

  matchingDashboardMentors.forEach(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ fieldName, arguments: variables }: { fieldName: string; arguments: any }) => {
      if (variables) {
        cache.invalidate("Query", fieldName, variables);
      }
    }
  );
}
